/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */
import { type SearchOptionType, type SearchOptionProps } from './types';
import type { SearchWorkflowViewModel } from '../../SearchWorkflowViewModel';
import type { SearchWorkflowStageTaskViewModel } from '../../SearchWorkflowStageTaskViewModel';
import type { SearchWorkflowStageViewModel } from '../../SearchWorkflowStageViewModel';
import type { SearchWorkflowStageTaskDefinitionsViewModel } from '../../SearchWorkflowStageTaskDefinitionsViewModel';
import type { SearchVisitViewModel } from '../../SearchVisitViewModel';
import type { SearchEvvExceptionViewModel } from '../../SearchEvvExceptionViewModel';
import type { SearchPlanOfCareReviewsViewModel } from '../../SearchPlanOfCareReviewsViewModel';
import type { SearchOrdersViewModel } from '../../SearchOrdersViewModel';
import type { SearchRequiresAttentionViewModel } from '../../SearchRequiresAttentionViewModel';
import type { SearchOutstandingOrderSignatureTotalsByPhysicianViewModel } from '../../SearchOutstandingOrderSignatureTotalsByPhysicianViewModel';
import type { SearchInProgressFaxTotalsViewModel } from '../../SearchInProgressFaxTotalsViewModel';
import type { SearchInProgressFaxTotalsByPhysicianViewModel } from '../../SearchInProgressFaxTotalsByPhysicianViewModel';
import type { SearchInProgressFaxTotalsByPatientViewModel } from '../../SearchInProgressFaxTotalsByPatientViewModel';
import type { SearchInProgressFaxTotalsByOrderTypeViewModel } from '../../SearchInProgressFaxTotalsByOrderTypeViewModel';
import type { SearchInProgressFaxTotalsByTeamViewModel } from '../../SearchInProgressFaxTotalsByTeamViewModel';
import type { SearchInProgressFaxOrderSignatureViewModel } from '../../SearchInProgressFaxOrderSignatureViewModel';
import type { SearchInProgressDigitalTotalsViewModel } from '../../SearchInProgressDigitalTotalsViewModel';
import type { SearchInProgressDigitalTotalsByPhysicianViewModel } from '../../SearchInProgressDigitalTotalsByPhysicianViewModel';
import type { SearchInProgressDigitalTotalsByPatientViewModel } from '../../SearchInProgressDigitalTotalsByPatientViewModel';
import type { SearchInProgressDigitalTotalsByOrderTypeViewModel } from '../../SearchInProgressDigitalTotalsByOrderTypeViewModel';
import type { SearchInProgressDigitalTotalsByTeamViewModel } from '../../SearchInProgressDigitalTotalsByTeamViewModel';
import type { SearchInProgressDigitalOrderSignatureViewModel } from '../../SearchInProgressDigitalOrderSignatureViewModel';
import type { SearchInProgressCourierTotalsViewModel } from '../../SearchInProgressCourierTotalsViewModel';
import type { SearchInProgressCourierTotalsByPhysicianViewModel } from '../../SearchInProgressCourierTotalsByPhysicianViewModel';
import type { SearchInProgressCourierTotalsByPatientViewModel } from '../../SearchInProgressCourierTotalsByPatientViewModel';
import type { SearchInProgressCourierTotalsByOrderTypeViewModel } from '../../SearchInProgressCourierTotalsByOrderTypeViewModel';
import type { SearchInProgressCourierTotalsByTeamViewModel } from '../../SearchInProgressCourierTotalsByTeamViewModel';
import type { SearchInProgressCourierOrderSignatureViewModel } from '../../SearchInProgressCourierOrderSignatureViewModel';
import type { SearchOasisExportBatchViewModel } from '../../SearchOasisExportBatchViewModel';
import type { SearchOasisAssessmentViewModel } from '../../SearchOasisAssessmentViewModel';
import type { SearchOasisDefinitionsViewModel } from '../../SearchOasisDefinitionsViewModel';
import type { SearchUserViewModel } from '../../SearchUserViewModel';
import type { SearchSupplyViewModel } from '../../SearchSupplyViewModel';
import type { SearchSupplierViewModel } from '../../SearchSupplierViewModel';
import type { SearchPhysicianViewModel } from '../../SearchPhysicianViewModel';
import type { SearchPhysicianGroupViewModel } from '../../SearchPhysicianGroupViewModel';
import type { SearchPharmacyViewModel } from '../../SearchPharmacyViewModel';
import type { SearchInsurancProviderPlansViewModel } from '../../SearchInsurancProviderPlansViewModel';
import type { SearchInsuranceProviderViewModel } from '../../SearchInsuranceProviderViewModel';
import type { SearchIcdDiagnosisViewModel } from '../../SearchIcdDiagnosisViewModel';
import type { SearchFacilityViewModel } from '../../SearchFacilityViewModel';
import type { SearchConceptViewModel } from '../../SearchConceptViewModel';
import type { SearchConceptCategoriesViewModel } from '../../SearchConceptCategoriesViewModel';
import type { SearchBranchViewModel } from '../../SearchBranchViewModel';
import type { SearchLegacyWoundPatientViewModel } from '../../SearchLegacyWoundPatientViewModel';
import type { SearchLegacyClinicianViewModel } from '../../SearchLegacyClinicianViewModel';
import type { SearchLegacyUserViewModel } from '../../SearchLegacyUserViewModel';
import type { SearchScheduleReportTotalsDiscplineViewModel } from '../../SearchScheduleReportTotalsDiscplineViewModel';
import type { SearchScheduleReportTotalsDiscplineUnassignedViewModel } from '../../SearchScheduleReportTotalsDiscplineUnassignedViewModel';
import type { SearchScheduleReportTotalsPatientViewModel } from '../../SearchScheduleReportTotalsPatientViewModel';
import type { SearchScheduleReportTotalsPatientUnassignedViewModel } from '../../SearchScheduleReportTotalsPatientUnassignedViewModel';
import type { SearchScheduleReportAssignedToViewModel } from '../../SearchScheduleReportAssignedToViewModel';
import type { SearchScheduleReportPatientViewModel } from '../../SearchScheduleReportPatientViewModel';
import type { SearchScheduleReportPrimaryInsuranceViewModel } from '../../SearchScheduleReportPrimaryInsuranceViewModel';
import type { SearchScheduleReportAdmittedEpisodeTotalsViewModel } from '../../SearchScheduleReportAdmittedEpisodeTotalsViewModel';
import type { SearchScheduleReportTotalsAssignedToViewModel } from '../../SearchScheduleReportTotalsAssignedToViewModel';
import type { SearchScheduleReportViewModel } from '../../SearchScheduleReportViewModel';
import type { SearchScheduleReportTotalsTeamViewModel } from '../../SearchScheduleReportTotalsTeamViewModel';
import type { SearchScheduleReportTotalsTeamUnassignedViewModel } from '../../SearchScheduleReportTotalsTeamUnassignedViewModel';
import type { SearchLegacyReferralViewModel } from '../../SearchLegacyReferralViewModel';
import type { SearchLegacyReferralNotificationViewModel } from '../../SearchLegacyReferralNotificationViewModel';
import type { SearchLegacyChartProfilesViewModel } from '../../SearchLegacyChartProfilesViewModel';
import type { SearchLegacyCurrentPatientViewModel } from '../../SearchLegacyCurrentPatientViewModel';
import type { SearchLegacyPatientsViewModel } from '../../SearchLegacyPatientsViewModel';
import type { SearchLegacyOasisTrackingViewModel } from '../../SearchLegacyOasisTrackingViewModel';
import type { SearchLegacyOasisTrackingAveragesViewModel } from '../../SearchLegacyOasisTrackingAveragesViewModel';
import type { SearchCareportFacilityViewModel } from '../../SearchCareportFacilityViewModel';
import type { SearchCareportStaysViewModel } from '../../SearchCareportStaysViewModel';
import type { SearchCareportVisitsViewModel } from '../../SearchCareportVisitsViewModel';
import type { SearchPendingReferralViewModel } from '../../SearchPendingReferralViewModel';
import type { SearchPatientViewModel } from '../../SearchPatientViewModel';
import type { SearchNtfcViewModel } from '../../SearchNtfcViewModel';
import type { SearchCertificationPeriodViewModel } from '../../SearchCertificationPeriodViewModel';
import type { SearchAdmissionViewModel } from '../../SearchAdmissionViewModel';
import type { SearchHospitalEventViewModel } from '../../SearchHospitalEventViewModel';
import type { SearchAcuteVisitViewModel } from '../../SearchAcuteVisitViewModel';
import type { SearchInfectionViewModel } from '../../SearchInfectionViewModel';
import type { SearchFrequencyViewModel } from '../../SearchFrequencyViewModel';
import type { SearchLaboratoryViewModel } from '../../SearchLaboratoryViewModel';
import type { SearchLabDefinitionViewModel } from '../../SearchLabDefinitionViewModel';
import type { SearchStoredDocumentViewModel } from '../../SearchStoredDocumentViewModel';
import type { SearchPatientPhysicianViewModel } from '../../SearchPatientPhysicianViewModel';
import type { SearchPatientPhysicianAppointmentViewModel } from '../../SearchPatientPhysicianAppointmentViewModel';
import type { SearchPatientDemographicsViewModel } from '../../SearchPatientDemographicsViewModel';
import type { SearchCareTeamViewModel } from '../../SearchCareTeamViewModel';
import type { SearchCareFeedEventViewModel } from '../../SearchCareFeedEventViewModel';
import type { SearchConceptDocumentationViewModel } from '../../SearchConceptDocumentationViewModel';
import type { SearchInterventionDefinitionsViewModel } from '../../SearchInterventionDefinitionsViewModel';
import type { SearchGoalDefinitionsViewModel } from '../../SearchGoalDefinitionsViewModel';
import type { SearchNoticeOfAdmissionViewModel } from '../../SearchNoticeOfAdmissionViewModel';
import type { SearchPatientInsuranceViewModel } from '../../SearchPatientInsuranceViewModel';
import type { SearchFaceToFaceViewModel } from '../../SearchFaceToFaceViewModel';
import type { SearchBillingPeriodViewModel } from '../../SearchBillingPeriodViewModel';
import type { SearchBillableVisitViewModel } from '../../SearchBillableVisitViewModel';

export type SearchTypeToModel = {
	'acute-visit': SearchAcuteVisitViewModel;
	'admission': SearchAdmissionViewModel;
	'billable-visit': SearchBillableVisitViewModel;
	'billing-period': SearchBillingPeriodViewModel;
	'branch': SearchBranchViewModel;
	'care-feed-event': SearchCareFeedEventViewModel;
	'care-team': SearchCareTeamViewModel;
	'careport-facility': SearchCareportFacilityViewModel;
	'careport-stays': SearchCareportStaysViewModel;
	'careport-visits': SearchCareportVisitsViewModel;
	'certification-period': SearchCertificationPeriodViewModel;
	'concept': SearchConceptViewModel;
	'concept-categories': SearchConceptCategoriesViewModel;
	'concept-documentation': SearchConceptDocumentationViewModel;
	'evv-exception': SearchEvvExceptionViewModel;
	'face-to-face': SearchFaceToFaceViewModel;
	'facility': SearchFacilityViewModel;
	'frequency': SearchFrequencyViewModel;
	'goal-definitions': SearchGoalDefinitionsViewModel;
	'hospital-event': SearchHospitalEventViewModel;
	'icd-diagnosis': SearchIcdDiagnosisViewModel;
	'in-progress-courier-order-signature': SearchInProgressCourierOrderSignatureViewModel;
	'in-progress-courier-totals': SearchInProgressCourierTotalsViewModel;
	'in-progress-courier-totals-by-order-type': SearchInProgressCourierTotalsByOrderTypeViewModel;
	'in-progress-courier-totals-by-patient': SearchInProgressCourierTotalsByPatientViewModel;
	'in-progress-courier-totals-by-physician': SearchInProgressCourierTotalsByPhysicianViewModel;
	'in-progress-courier-totals-by-team': SearchInProgressCourierTotalsByTeamViewModel;
	'in-progress-digital-order-signature': SearchInProgressDigitalOrderSignatureViewModel;
	'in-progress-digital-totals': SearchInProgressDigitalTotalsViewModel;
	'in-progress-digital-totals-by-order-type': SearchInProgressDigitalTotalsByOrderTypeViewModel;
	'in-progress-digital-totals-by-patient': SearchInProgressDigitalTotalsByPatientViewModel;
	'in-progress-digital-totals-by-physician': SearchInProgressDigitalTotalsByPhysicianViewModel;
	'in-progress-digital-totals-by-team': SearchInProgressDigitalTotalsByTeamViewModel;
	'in-progress-fax-order-signature': SearchInProgressFaxOrderSignatureViewModel;
	'in-progress-fax-totals': SearchInProgressFaxTotalsViewModel;
	'in-progress-fax-totals-by-order-type': SearchInProgressFaxTotalsByOrderTypeViewModel;
	'in-progress-fax-totals-by-patient': SearchInProgressFaxTotalsByPatientViewModel;
	'in-progress-fax-totals-by-physician': SearchInProgressFaxTotalsByPhysicianViewModel;
	'in-progress-fax-totals-by-team': SearchInProgressFaxTotalsByTeamViewModel;
	'infection': SearchInfectionViewModel;
	'insuranc-provider-plans': SearchInsurancProviderPlansViewModel;
	'insurance-provider': SearchInsuranceProviderViewModel;
	'intervention-definitions': SearchInterventionDefinitionsViewModel;
	'lab-definition': SearchLabDefinitionViewModel;
	'laboratory': SearchLaboratoryViewModel;
	'legacy-chart-profiles': SearchLegacyChartProfilesViewModel;
	'legacy-clinician': SearchLegacyClinicianViewModel;
	'legacy-current-patient': SearchLegacyCurrentPatientViewModel;
	'legacy-oasis-tracking': SearchLegacyOasisTrackingViewModel;
	'legacy-oasis-tracking-averages': SearchLegacyOasisTrackingAveragesViewModel;
	'legacy-patients': SearchLegacyPatientsViewModel;
	'legacy-referral': SearchLegacyReferralViewModel;
	'legacy-referral-notification': SearchLegacyReferralNotificationViewModel;
	'legacy-user': SearchLegacyUserViewModel;
	'legacy-wound-patient': SearchLegacyWoundPatientViewModel;
	'notice-of-admission': SearchNoticeOfAdmissionViewModel;
	'ntfc': SearchNtfcViewModel;
	'oasis-assessment': SearchOasisAssessmentViewModel;
	'oasis-definitions': SearchOasisDefinitionsViewModel;
	'oasis-export-batch': SearchOasisExportBatchViewModel;
	'orders': SearchOrdersViewModel;
	'outstanding-order-signature-totals-by-physician': SearchOutstandingOrderSignatureTotalsByPhysicianViewModel;
	'patient': SearchPatientViewModel;
	'patient-demographics': SearchPatientDemographicsViewModel;
	'patient-insurance': SearchPatientInsuranceViewModel;
	'patient-physician': SearchPatientPhysicianViewModel;
	'patient-physician-appointment': SearchPatientPhysicianAppointmentViewModel;
	'pending-referral': SearchPendingReferralViewModel;
	'pharmacy': SearchPharmacyViewModel;
	'physician': SearchPhysicianViewModel;
	'physician-group': SearchPhysicianGroupViewModel;
	'plan-of-care-reviews': SearchPlanOfCareReviewsViewModel;
	'requires-attention': SearchRequiresAttentionViewModel;
	'schedule-report': SearchScheduleReportViewModel;
	'schedule-report-admitted-episode-totals': SearchScheduleReportAdmittedEpisodeTotalsViewModel;
	'schedule-report-assigned-to': SearchScheduleReportAssignedToViewModel;
	'schedule-report-patient': SearchScheduleReportPatientViewModel;
	'schedule-report-primary-insurance': SearchScheduleReportPrimaryInsuranceViewModel;
	'schedule-report-totals-assigned-to': SearchScheduleReportTotalsAssignedToViewModel;
	'schedule-report-totals-discpline': SearchScheduleReportTotalsDiscplineViewModel;
	'schedule-report-totals-discpline-unassigned': SearchScheduleReportTotalsDiscplineUnassignedViewModel;
	'schedule-report-totals-patient': SearchScheduleReportTotalsPatientViewModel;
	'schedule-report-totals-patient-unassigned': SearchScheduleReportTotalsPatientUnassignedViewModel;
	'schedule-report-totals-team': SearchScheduleReportTotalsTeamViewModel;
	'schedule-report-totals-team-unassigned': SearchScheduleReportTotalsTeamUnassignedViewModel;
	'stored-document': SearchStoredDocumentViewModel;
	'supplier': SearchSupplierViewModel;
	'supply': SearchSupplyViewModel;
	'user': SearchUserViewModel;
	'visit': SearchVisitViewModel;
	'workflow': SearchWorkflowViewModel;
	'workflow-stage': SearchWorkflowStageViewModel;
	'workflow-stage-task': SearchWorkflowStageTaskViewModel;
	'workflow-stage-task-definitions': SearchWorkflowStageTaskDefinitionsViewModel;
};

//#region Search Type Props

const SearchWorkflowViewModelProps: SearchOptionProps<SearchWorkflowViewModel> = {
    searchType: 'workflow',
    endpoint: '_api/v1/homehealth/workflows/queries/searchworkflows/searchworkflow',
    defaultSortColumn: 'dueAt'
};
const SearchWorkflowStageTaskViewModelProps: SearchOptionProps<SearchWorkflowStageTaskViewModel> = {
    searchType: 'workflow-stage-task',
    endpoint: '_api/v1/homehealth/workflows/queries/searchworkflowstagetasks/searchworkflowstagetask',
    defaultSortColumn: 'dueAt'
};
const SearchWorkflowStageViewModelProps: SearchOptionProps<SearchWorkflowStageViewModel> = {
    searchType: 'workflow-stage',
    endpoint: '_api/v1/homehealth/workflows/queries/searchworkflowstages/searchworkflowstage',
    defaultSortColumn: 'dueAt'
};
const SearchWorkflowStageTaskDefinitionsViewModelProps: SearchOptionProps<SearchWorkflowStageTaskDefinitionsViewModel> = {
    searchType: 'workflow-stage-task-definitions',
    endpoint: '_api/v1/homehealth/workflows/definitions/queries/searchworkflowstagetaskdefinitions/searchworkflowstagetaskdefinitions',
    defaultSortColumn: 'systemName'
};
const SearchVisitViewModelProps: SearchOptionProps<SearchVisitViewModel> = {
    searchType: 'visit',
    endpoint: '_api/v1/homehealth/visits/queries/searchvisits/searchvisit',
    defaultSortColumn: 'timeIn'
};
const SearchEvvExceptionViewModelProps: SearchOptionProps<SearchEvvExceptionViewModel> = {
    searchType: 'evv-exception',
    endpoint: '_api/v1/homehealth/visits/queries/searchevvexceptions/searchevvexception',
    defaultSortColumn: 'occurredOn'
};
const SearchPlanOfCareReviewsViewModelProps: SearchOptionProps<SearchPlanOfCareReviewsViewModel> = {
    searchType: 'plan-of-care-reviews',
    endpoint: '_api/v1/homehealth/qa/queries/searchplanofcarereviews/searchplanofcarereviews',
    defaultSortColumn: 'dateCreated'
};
const SearchOrdersViewModelProps: SearchOptionProps<SearchOrdersViewModel> = {
    searchType: 'orders',
    endpoint: '_api/v1/homehealth/orders/queries/searchorders/searchorders',
    defaultSortColumn: 'orderDate',
	defaultSortDirection: 'desc'
};
const SearchRequiresAttentionViewModelProps: SearchOptionProps<SearchRequiresAttentionViewModel> = {
    searchType: 'requires-attention',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/searchrequiresattention/searchrequiresattention',
    defaultSortColumn: 'flaggedAt'
};
const SearchOutstandingOrderSignatureTotalsByPhysicianViewModelProps: SearchOptionProps<SearchOutstandingOrderSignatureTotalsByPhysicianViewModel> = {
    searchType: 'outstanding-order-signature-totals-by-physician',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/searchoutstandingordersignaturetotalsbyphysician/searchoutstandingordersignaturetotalsbyphysician',
    defaultSortColumn: 'orderingPhysicianName'
};
const SearchInProgressFaxTotalsViewModelProps: SearchOptionProps<SearchInProgressFaxTotalsViewModel> = {
    searchType: 'in-progress-fax-totals',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/faxqueries/searchinprogressfaxtotals/searchinprogressfaxtotals',
    defaultSortColumn: 'queuedToSendCount'
};
const SearchInProgressFaxTotalsByPhysicianViewModelProps: SearchOptionProps<SearchInProgressFaxTotalsByPhysicianViewModel> = {
    searchType: 'in-progress-fax-totals-by-physician',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/faxqueries/searchinprogressfaxtotals/searchinprogressfaxtotalsbyphysician',
    defaultSortColumn: 'orderingPhysicianName'
};
const SearchInProgressFaxTotalsByPatientViewModelProps: SearchOptionProps<SearchInProgressFaxTotalsByPatientViewModel> = {
    searchType: 'in-progress-fax-totals-by-patient',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/faxqueries/searchinprogressfaxtotals/searchinprogressfaxtotalsbypatient',
    defaultSortColumn: 'patientName'
};
const SearchInProgressFaxTotalsByOrderTypeViewModelProps: SearchOptionProps<SearchInProgressFaxTotalsByOrderTypeViewModel> = {
    searchType: 'in-progress-fax-totals-by-order-type',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/faxqueries/searchinprogressfaxtotals/searchinprogressfaxtotalsbyordertype',
    defaultSortColumn: 'orderTypeLabel'
};
const SearchInProgressFaxTotalsByTeamViewModelProps: SearchOptionProps<SearchInProgressFaxTotalsByTeamViewModel> = {
    searchType: 'in-progress-fax-totals-by-team',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/faxqueries/searchinprogressfaxtotals/searchinprogressfaxtotalsbyteam',
    defaultSortColumn: 'teamName'
};
const SearchInProgressFaxOrderSignatureViewModelProps: SearchOptionProps<SearchInProgressFaxOrderSignatureViewModel> = {
    searchType: 'in-progress-fax-order-signature',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/faxqueries/searchinprogressfaxordersignatures/searchinprogressfaxordersignature',
    defaultSortColumn: 'orderingPhysicianName'
};
const SearchInProgressDigitalTotalsViewModelProps: SearchOptionProps<SearchInProgressDigitalTotalsViewModel> = {
    searchType: 'in-progress-digital-totals',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/digitalqueries/searchinprogressdigitaltotals/searchinprogressdigitaltotals',
    defaultSortColumn: 'sentToPhysicianCount'
};
const SearchInProgressDigitalTotalsByPhysicianViewModelProps: SearchOptionProps<SearchInProgressDigitalTotalsByPhysicianViewModel> = {
    searchType: 'in-progress-digital-totals-by-physician',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/digitalqueries/searchinprogressdigitaltotals/searchinprogressdigitaltotalsbyphysician',
    defaultSortColumn: 'orderingPhysicianName'
};
const SearchInProgressDigitalTotalsByPatientViewModelProps: SearchOptionProps<SearchInProgressDigitalTotalsByPatientViewModel> = {
    searchType: 'in-progress-digital-totals-by-patient',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/digitalqueries/searchinprogressdigitaltotals/searchinprogressdigitaltotalsbypatient',
    defaultSortColumn: 'patientName'
};
const SearchInProgressDigitalTotalsByOrderTypeViewModelProps: SearchOptionProps<SearchInProgressDigitalTotalsByOrderTypeViewModel> = {
    searchType: 'in-progress-digital-totals-by-order-type',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/digitalqueries/searchinprogressdigitaltotals/searchinprogressdigitaltotalsbyordertype',
    defaultSortColumn: 'orderTypeLabel'
};
const SearchInProgressDigitalTotalsByTeamViewModelProps: SearchOptionProps<SearchInProgressDigitalTotalsByTeamViewModel> = {
    searchType: 'in-progress-digital-totals-by-team',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/digitalqueries/searchinprogressdigitaltotals/searchinprogressdigitaltotalsbyteam',
    defaultSortColumn: 'teamName'
};
const SearchInProgressDigitalOrderSignatureViewModelProps: SearchOptionProps<SearchInProgressDigitalOrderSignatureViewModel> = {
    searchType: 'in-progress-digital-order-signature',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/digitalqueries/searchinprogressdigitalordersignatures/searchinprogressdigitalordersignature',
    defaultSortColumn: 'orderingPhysicianName'
};
const SearchInProgressCourierTotalsViewModelProps: SearchOptionProps<SearchInProgressCourierTotalsViewModel> = {
    searchType: 'in-progress-courier-totals',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/courierqueries/searchinprogresscouriertotals/searchinprogresscouriertotals',
    defaultSortColumn: 'readyToSendCount'
};
const SearchInProgressCourierTotalsByPhysicianViewModelProps: SearchOptionProps<SearchInProgressCourierTotalsByPhysicianViewModel> = {
    searchType: 'in-progress-courier-totals-by-physician',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/courierqueries/searchinprogresscouriertotals/searchinprogresscouriertotalsbyphysician',
    defaultSortColumn: 'orderingPhysicianName'
};
const SearchInProgressCourierTotalsByPatientViewModelProps: SearchOptionProps<SearchInProgressCourierTotalsByPatientViewModel> = {
    searchType: 'in-progress-courier-totals-by-patient',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/courierqueries/searchinprogresscouriertotals/searchinprogresscouriertotalsbypatient',
    defaultSortColumn: 'patientName'
};
const SearchInProgressCourierTotalsByOrderTypeViewModelProps: SearchOptionProps<SearchInProgressCourierTotalsByOrderTypeViewModel> = {
    searchType: 'in-progress-courier-totals-by-order-type',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/courierqueries/searchinprogresscouriertotals/searchinprogresscouriertotalsbyordertype',
    defaultSortColumn: 'orderTypeLabel'
};
const SearchInProgressCourierTotalsByTeamViewModelProps: SearchOptionProps<SearchInProgressCourierTotalsByTeamViewModel> = {
    searchType: 'in-progress-courier-totals-by-team',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/courierqueries/searchinprogresscouriertotals/searchinprogresscouriertotalsbyteam',
    defaultSortColumn: 'teamName'
};
const SearchInProgressCourierOrderSignatureViewModelProps: SearchOptionProps<SearchInProgressCourierOrderSignatureViewModel> = {
    searchType: 'in-progress-courier-order-signature',
    endpoint: '_api/v1/homehealth/orders/ordersigning/queries/courierqueries/searchinprogresscourierordersignatures/searchinprogresscourierordersignature',
    defaultSortColumn: 'orderingPhysicianName'
};
const SearchOasisExportBatchViewModelProps: SearchOptionProps<SearchOasisExportBatchViewModel> = {
    searchType: 'oasis-export-batch',
    endpoint: '_api/v1/homehealth/oasis/queries/searchoasisexportbatches/searchoasisexportbatch',
    defaultSortColumn: 'startedOn',
	defaultSortDirection: 'desc'
};
const SearchOasisAssessmentViewModelProps: SearchOptionProps<SearchOasisAssessmentViewModel> = {
    searchType: 'oasis-assessment',
    endpoint: '_api/v1/homehealth/oasis/queries/searchoasisassessments/searchoasisassessment',
    defaultSortColumn: 'dateCreated'
};
const SearchOasisDefinitionsViewModelProps: SearchOptionProps<SearchOasisDefinitionsViewModel> = {
    searchType: 'oasis-definitions',
    endpoint: '_api/v1/homehealth/oasis/definitions/queries/searchoasisdefinitions/searchoasisdefinitions',
    defaultSortColumn: 'title'
};
const SearchUserViewModelProps: SearchOptionProps<SearchUserViewModel> = {
    searchType: 'user',
    endpoint: '_api/v1/homehealth/libraries/users/queries/searchusers/searchuser',
    defaultSortColumn: 'name'
};
const SearchSupplyViewModelProps: SearchOptionProps<SearchSupplyViewModel> = {
    searchType: 'supply',
    endpoint: '_api/v1/homehealth/libraries/supplies/queries/searchsupplies/searchsupply',
    defaultSortColumn: 'name'
};
const SearchSupplierViewModelProps: SearchOptionProps<SearchSupplierViewModel> = {
    searchType: 'supplier',
    endpoint: '_api/v1/suppliers/searchsupplier',
    defaultSortColumn: 'name'
};
const SearchPhysicianViewModelProps: SearchOptionProps<SearchPhysicianViewModel> = {
    searchType: 'physician',
    endpoint: '_api/v1/homehealth/libraries/physicians/queries/searchphysicians/searchphysician',
    defaultSortColumn: 'name'
};
const SearchPhysicianGroupViewModelProps: SearchOptionProps<SearchPhysicianGroupViewModel> = {
    searchType: 'physician-group',
    endpoint: '_api/v1/homehealth/libraries/physicians/queries/searchphysiciangroups/searchphysiciangroup',
    defaultSortColumn: 'dateCreated'
};
const SearchPharmacyViewModelProps: SearchOptionProps<SearchPharmacyViewModel> = {
    searchType: 'pharmacy',
    endpoint: '_api/v1/homehealth/libraries/pharmacies/queries/searchpharmacies/searchpharmacy',
    defaultSortColumn: 'name'
};
const SearchInsurancProviderPlansViewModelProps: SearchOptionProps<SearchInsurancProviderPlansViewModel> = {
    searchType: 'insuranc-provider-plans',
    endpoint: '_api/v1/homehealth/libraries/insuranceproviders/queries/searchinsurancproviderplans/searchinsurancproviderplans',
    defaultSortColumn: 'name'
};
const SearchInsuranceProviderViewModelProps: SearchOptionProps<SearchInsuranceProviderViewModel> = {
    searchType: 'insurance-provider',
    endpoint: '_api/v1/homehealth/libraries/insuranceproviders/queries/searchinsuranceproviders/searchinsuranceprovider',
    defaultSortColumn: 'name'
};
const SearchIcdDiagnosisViewModelProps: SearchOptionProps<SearchIcdDiagnosisViewModel> = {
    searchType: 'icd-diagnosis',
    endpoint: '_api/v1/homehealth/libraries/icddiagnoses/queries/searchicddiagnoses/searchicddiagnosis',
    defaultSortColumn: 'diagnosisLabel'
};
const SearchFacilityViewModelProps: SearchOptionProps<SearchFacilityViewModel> = {
    searchType: 'facility',
    endpoint: '_api/v1/homehealth/libraries/facilities/queries/searchfacilities/searchfacility',
    defaultSortColumn: 'name'
};
const SearchConceptViewModelProps: SearchOptionProps<SearchConceptViewModel> = {
    searchType: 'concept',
    endpoint: '_api/v1/homehealth/libraries/concepts/queries/searchconcepts/searchconcept',
    defaultSortColumn: 'label'
};
const SearchConceptCategoriesViewModelProps: SearchOptionProps<SearchConceptCategoriesViewModel> = {
    searchType: 'concept-categories',
    endpoint: '_api/v1/homehealth/libraries/concepts/queries/searchconceptcategories/searchconceptcategories',
    defaultSortColumn: 'label'
};
const SearchBranchViewModelProps: SearchOptionProps<SearchBranchViewModel> = {
    searchType: 'branch',
    endpoint: '_api/v1/homehealth/libraries/agenciessettings/queries/searchbranches/searchbranch',
    defaultSortColumn: 'name'
};
const SearchLegacyWoundPatientViewModelProps: SearchOptionProps<SearchLegacyWoundPatientViewModel> = {
    searchType: 'legacy-wound-patient',
    endpoint: '_api/v1/homehealth/legacy/wounds/searchlegacywoundpatient',
    defaultSortColumn: 'patientName'
};
const SearchLegacyClinicianViewModelProps: SearchOptionProps<SearchLegacyClinicianViewModel> = {
    searchType: 'legacy-clinician',
    endpoint: '_api/v1/homehealth/legacy/users/searchlegacyclinician',
    defaultSortColumn: 'id'
};
const SearchLegacyUserViewModelProps: SearchOptionProps<SearchLegacyUserViewModel> = {
    searchType: 'legacy-user',
    endpoint: '_api/v1/homehealth/legacy/users/searchlegacyuser',
    defaultSortColumn: 'name'
};
const SearchScheduleReportTotalsDiscplineViewModelProps: SearchOptionProps<SearchScheduleReportTotalsDiscplineViewModel> = {
    searchType: 'schedule-report-totals-discpline',
    endpoint: '_api/v1/homehealth/legacy/scheduling/queries/searchschedulereporttotalsdiscpline',
    defaultSortColumn: 'discipline'
};
const SearchScheduleReportTotalsDiscplineUnassignedViewModelProps: SearchOptionProps<SearchScheduleReportTotalsDiscplineUnassignedViewModel> = {
    searchType: 'schedule-report-totals-discpline-unassigned',
    endpoint: '_api/v1/homehealth/legacy/scheduling/queries/searchschedulereporttotalsdiscplineunassigned',
    defaultSortColumn: 'discipline'
};
const SearchScheduleReportTotalsPatientViewModelProps: SearchOptionProps<SearchScheduleReportTotalsPatientViewModel> = {
    searchType: 'schedule-report-totals-patient',
    endpoint: '_api/v1/homehealth/legacy/scheduling/queries/searchschedulereporttotalspatient',
    defaultSortColumn: 'patientName'
};
const SearchScheduleReportTotalsPatientUnassignedViewModelProps: SearchOptionProps<SearchScheduleReportTotalsPatientUnassignedViewModel> = {
    searchType: 'schedule-report-totals-patient-unassigned',
    endpoint: '_api/v1/homehealth/legacy/scheduling/queries/searchschedulereporttotalspatientunassigned',
    defaultSortColumn: 'patientName'
};
const SearchScheduleReportAssignedToViewModelProps: SearchOptionProps<SearchScheduleReportAssignedToViewModel> = {
    searchType: 'schedule-report-assigned-to',
    endpoint: '_api/v1/homehealth/legacy/scheduling/queries/searchschedulereportassignedto',
    defaultSortColumn: 'name'
};
const SearchScheduleReportPatientViewModelProps: SearchOptionProps<SearchScheduleReportPatientViewModel> = {
    searchType: 'schedule-report-patient',
    endpoint: '_api/v1/homehealth/legacy/scheduling/queries/searchschedulereportpatient',
    defaultSortColumn: 'name'
};
const SearchScheduleReportPrimaryInsuranceViewModelProps: SearchOptionProps<SearchScheduleReportPrimaryInsuranceViewModel> = {
    searchType: 'schedule-report-primary-insurance',
    endpoint: '_api/v1/homehealth/legacy/scheduling/queries/searchschedulereportprimaryinsurance',
    defaultSortColumn: 'name'
};
const SearchScheduleReportAdmittedEpisodeTotalsViewModelProps: SearchOptionProps<SearchScheduleReportAdmittedEpisodeTotalsViewModel> = {
    searchType: 'schedule-report-admitted-episode-totals',
    endpoint: '_api/v1/homehealth/legacy/scheduling/queries/searchschedulereportadmittedepisodetotals',
    defaultSortColumn: 'patientName'
};
const SearchScheduleReportTotalsAssignedToViewModelProps: SearchOptionProps<SearchScheduleReportTotalsAssignedToViewModel> = {
    searchType: 'schedule-report-totals-assigned-to',
    endpoint: '_api/v1/homehealth/legacy/scheduling/queries/searchschedulereporttotalsassignedto',
    defaultSortColumn: 'assignedToName'
};
const SearchScheduleReportViewModelProps: SearchOptionProps<SearchScheduleReportViewModel> = {
    searchType: 'schedule-report',
    endpoint: '_api/v1/homehealth/legacy/scheduling/queries/searchschedulereport',
    defaultSortColumn: 'dateCreated'
};
const SearchScheduleReportTotalsTeamViewModelProps: SearchOptionProps<SearchScheduleReportTotalsTeamViewModel> = {
    searchType: 'schedule-report-totals-team',
    endpoint: '_api/v1/homehealth/legacy/scheduling/queries/searchschedulereporttotalsteam',
    defaultSortColumn: 'team'
};
const SearchScheduleReportTotalsTeamUnassignedViewModelProps: SearchOptionProps<SearchScheduleReportTotalsTeamUnassignedViewModel> = {
    searchType: 'schedule-report-totals-team-unassigned',
    endpoint: '_api/v1/homehealth/legacy/scheduling/queries/searchschedulereporttotalsteamunassigned',
    defaultSortColumn: 'team'
};
const SearchLegacyReferralViewModelProps: SearchOptionProps<SearchLegacyReferralViewModel> = {
    searchType: 'legacy-referral',
    endpoint: '_api/v1/homehealth/legacy/referrals/queries/searchlegacyreferrals/searchlegacyreferral',
    defaultSortColumn: 'dateCreated'
};
const SearchLegacyReferralNotificationViewModelProps: SearchOptionProps<SearchLegacyReferralNotificationViewModel> = {
    searchType: 'legacy-referral-notification',
    endpoint: '_api/v1/homehealth/legacy/referrals/queries/searchlegacyreferralnotifications/searchlegacyreferralnotification',
    defaultSortColumn: 'dateCreated'
};
const SearchLegacyChartProfilesViewModelProps: SearchOptionProps<SearchLegacyChartProfilesViewModel> = {
    searchType: 'legacy-chart-profiles',
    endpoint: '_api/v1/homehealth/legacy/patients/searchlegacychartprofiles',
    defaultSortColumn: 'patientCode'
};
const SearchLegacyCurrentPatientViewModelProps: SearchOptionProps<SearchLegacyCurrentPatientViewModel> = {
    searchType: 'legacy-current-patient',
    endpoint: '_api/v1/homehealth/legacy/patients/searchlegacycurrentpatient',
    defaultSortColumn: 'patientName'
};
const SearchLegacyPatientsViewModelProps: SearchOptionProps<SearchLegacyPatientsViewModel> = {
    searchType: 'legacy-patients',
    endpoint: '_api/v1/homehealth/legacy/patients/searchlegacypatients',
    defaultSortColumn: 'patientLabel'
};
const SearchLegacyOasisTrackingViewModelProps: SearchOptionProps<SearchLegacyOasisTrackingViewModel> = {
    searchType: 'legacy-oasis-tracking',
    endpoint: '_api/v1/homehealth/legacy/oasis/searchlegacyoasistracking',
    defaultSortColumn: 'visitDate',
	defaultSortDirection: 'desc'
};
const SearchLegacyOasisTrackingAveragesViewModelProps: SearchOptionProps<SearchLegacyOasisTrackingAveragesViewModel> = {
    searchType: 'legacy-oasis-tracking-averages',
    endpoint: '_api/v1/homehealth/legacy/oasis/searchlegacyoasistrackingaverages',
    defaultSortColumn: 'name'
};
const SearchCareportFacilityViewModelProps: SearchOptionProps<SearchCareportFacilityViewModel> = {
    searchType: 'careport-facility',
    endpoint: '_api/v1/homehealth/legacy/hospitalizations/searchcareportfacility',
    defaultSortColumn: 'name'
};
const SearchCareportStaysViewModelProps: SearchOptionProps<SearchCareportStaysViewModel> = {
    searchType: 'careport-stays',
    endpoint: '_api/v1/homehealth/legacy/hospitalizations/searchcareportstays',
    defaultSortColumn: 'lastStatusDateTime'
};
const SearchCareportVisitsViewModelProps: SearchOptionProps<SearchCareportVisitsViewModel> = {
    searchType: 'careport-visits',
    endpoint: '_api/v1/homehealth/legacy/hospitalizations/searchcareportvisits',
    defaultSortColumn: 'statusDateTime'
};
const SearchPendingReferralViewModelProps: SearchOptionProps<SearchPendingReferralViewModel> = {
    searchType: 'pending-referral',
    endpoint: '_api/v1/homehealth/intake/pendingreferrals/queries/searchpendingreferrals/searchpendingreferral',
    defaultSortColumn: 'referralDate'
};
const SearchPatientViewModelProps: SearchOptionProps<SearchPatientViewModel> = {
    searchType: 'patient',
    endpoint: '_api/v1/homehealth/intake/patients/queries/searchpatients/searchpatient',
    defaultSortColumn: 'name'
};
const SearchNtfcViewModelProps: SearchOptionProps<SearchNtfcViewModel> = {
    searchType: 'ntfc',
    endpoint: '_api/v1/homehealth/intake/admissions/queries/searchntfc/searchntfc',
    defaultSortColumn: 'referralDate'
};
const SearchCertificationPeriodViewModelProps: SearchOptionProps<SearchCertificationPeriodViewModel> = {
    searchType: 'certification-period',
    endpoint: '_api/v1/homehealth/intake/admissions/queries/searchcertificationperiods/searchcertificationperiod',
    defaultSortColumn: 'certificationNumber'
};
const SearchAdmissionViewModelProps: SearchOptionProps<SearchAdmissionViewModel> = {
    searchType: 'admission',
    endpoint: '_api/v1/homehealth/intake/admissions/queries/searchadmissions/searchadmission',
    defaultSortColumn: 'startOfCareDate'
};
const SearchHospitalEventViewModelProps: SearchOptionProps<SearchHospitalEventViewModel> = {
    searchType: 'hospital-event',
    endpoint: '_api/v1/homehealth/incidents/rehospitalizations/queries/searchhospitalevents/searchhospitalevent',
    defaultSortColumn: 'dateCreated'
};
const SearchAcuteVisitViewModelProps: SearchOptionProps<SearchAcuteVisitViewModel> = {
    searchType: 'acute-visit',
    endpoint: '_api/v1/homehealth/incidents/rehospitalizations/queries/searchacutevisits/searchacutevisit',
    defaultSortColumn: 'dateCreated'
};
const SearchInfectionViewModelProps: SearchOptionProps<SearchInfectionViewModel> = {
    searchType: 'infection',
    endpoint: '_api/v1/homehealth/incidents/infections/queries/searchinfections/searchinfection',
    defaultSortColumn: 'dateCreated'
};
const SearchFrequencyViewModelProps: SearchOptionProps<SearchFrequencyViewModel> = {
    searchType: 'frequency',
    endpoint: '_api/v1/homehealth/frequencies/queries/searchfrequencies/searchfrequency',
    defaultSortColumn: 'scheduledDateAndTime'
};
const SearchLaboratoryViewModelProps: SearchOptionProps<SearchLaboratoryViewModel> = {
    searchType: 'laboratory',
    endpoint: '_api/v1/homehealth/frequencies/laboratories/queries/searchlaboratories/searchlaboratory',
    defaultSortColumn: 'dateCreated'
};
const SearchLabDefinitionViewModelProps: SearchOptionProps<SearchLabDefinitionViewModel> = {
    searchType: 'lab-definition',
    endpoint: '_api/v1/homehealth/frequencies/definitions/queries/searchlabdefinitions/searchlabdefinition',
    defaultSortColumn: 'name'
};
const SearchStoredDocumentViewModelProps: SearchOptionProps<SearchStoredDocumentViewModel> = {
    searchType: 'stored-document',
    endpoint: '_api/v1/homehealth/documentstorage/queries/searchdocuments/searchstoreddocument',
    defaultSortColumn: 'dateCreated'
};
const SearchPatientPhysicianViewModelProps: SearchOptionProps<SearchPatientPhysicianViewModel> = {
    searchType: 'patient-physician',
    endpoint: '_api/v1/homehealth/demographics/patientsphysicians/queries/searchpatientphysicians/searchpatientphysician',
    defaultSortColumn: 'name'
};
const SearchPatientPhysicianAppointmentViewModelProps: SearchOptionProps<SearchPatientPhysicianAppointmentViewModel> = {
    searchType: 'patient-physician-appointment',
    endpoint: '_api/v1/homehealth/demographics/patientsphysicians/queries/searchpatientphysicianappts/searchpatientphysicianappointment',
    defaultSortColumn: 'appointmentDateAndTime'
};
const SearchPatientDemographicsViewModelProps: SearchOptionProps<SearchPatientDemographicsViewModel> = {
    searchType: 'patient-demographics',
    endpoint: '_api/v1/homehealth/demographics/demographics/queries/searchpatientdemographics/searchpatientdemographics',
    defaultSortColumn: 'name'
};
const SearchCareTeamViewModelProps: SearchOptionProps<SearchCareTeamViewModel> = {
    searchType: 'care-team',
    endpoint: '_api/v1/homehealth/coordination/careteams/queries/searchcareteam/searchcareteam',
    defaultSortColumn: 'clinicianName'
};
const SearchCareFeedEventViewModelProps: SearchOptionProps<SearchCareFeedEventViewModel> = {
    searchType: 'care-feed-event',
    endpoint: '_api/v1/homehealth/coordination/carefeed/queries/searchcarefeedevents/searchcarefeedevent',
    defaultSortColumn: 'dateCreated'
};
const SearchConceptDocumentationViewModelProps: SearchOptionProps<SearchConceptDocumentationViewModel> = {
    searchType: 'concept-documentation',
    endpoint: '_api/v1/homehealth/concepts/queries/searchconceptdocumentation/searchconceptdocumentation',
    defaultSortColumn: 'conceptLabel'
};
const SearchInterventionDefinitionsViewModelProps: SearchOptionProps<SearchInterventionDefinitionsViewModel> = {
    searchType: 'intervention-definitions',
    endpoint: '_api/v1/homehealth/careplanning/goalsandinterventions/definitions/queries/searchinterventiondefinitions/searchinterventiondefinitions',
    defaultSortColumn: 'title'
};
const SearchGoalDefinitionsViewModelProps: SearchOptionProps<SearchGoalDefinitionsViewModel> = {
    searchType: 'goal-definitions',
    endpoint: '_api/v1/homehealth/careplanning/goalsandinterventions/definitions/queries/searchgoaldefinitions/searchgoaldefinitions',
    defaultSortColumn: 'title'
};
const SearchNoticeOfAdmissionViewModelProps: SearchOptionProps<SearchNoticeOfAdmissionViewModel> = {
    searchType: 'notice-of-admission',
    endpoint: '_api/v1/homehealth/billing/noticesofadmission/queries/searchnoas/searchnoticeofadmission',
    defaultSortColumn: 'startOfCareDate'
};
const SearchPatientInsuranceViewModelProps: SearchOptionProps<SearchPatientInsuranceViewModel> = {
    searchType: 'patient-insurance',
    endpoint: '_api/v1/homehealth/billing/insurance/queries/searchpatientinsurance/searchpatientinsurance',
    defaultSortColumn: 'dateCreated'
};
const SearchFaceToFaceViewModelProps: SearchOptionProps<SearchFaceToFaceViewModel> = {
    searchType: 'face-to-face',
    endpoint: '_api/v1/homehealth/billing/facetofaces/queries/searchfacetofaces/searchfacetoface',
    defaultSortColumn: 'startOfCareDate'
};
const SearchBillingPeriodViewModelProps: SearchOptionProps<SearchBillingPeriodViewModel> = {
    searchType: 'billing-period',
    endpoint: '_api/v1/homehealth/billing/billings/queries/searchbillingperiods/searchbillingperiod',
    defaultSortColumn: 'billingPeriodStartDate'
};
const SearchBillableVisitViewModelProps: SearchOptionProps<SearchBillableVisitViewModel> = {
    searchType: 'billable-visit',
    endpoint: '_api/v1/homehealth/billing/billings/queries/searchbillablevisits/searchbillablevisit',
    defaultSortColumn: 'timeIn'
};


//#endregion

export function GetSearchProps<K extends SearchOptionType>(type: K): SearchOptionProps<SearchTypeToModel[K]> {
	switch (type) 
	{
		case 'workflow':
			return SearchWorkflowViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'workflow-stage-task':
			return SearchWorkflowStageTaskViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'workflow-stage':
			return SearchWorkflowStageViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'workflow-stage-task-definitions':
			return SearchWorkflowStageTaskDefinitionsViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'visit':
			return SearchVisitViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'evv-exception':
			return SearchEvvExceptionViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'plan-of-care-reviews':
			return SearchPlanOfCareReviewsViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'orders':
			return SearchOrdersViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'requires-attention':
			return SearchRequiresAttentionViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'outstanding-order-signature-totals-by-physician':
			return SearchOutstandingOrderSignatureTotalsByPhysicianViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-fax-totals':
			return SearchInProgressFaxTotalsViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-fax-totals-by-physician':
			return SearchInProgressFaxTotalsByPhysicianViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-fax-totals-by-patient':
			return SearchInProgressFaxTotalsByPatientViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-fax-totals-by-order-type':
			return SearchInProgressFaxTotalsByOrderTypeViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-fax-totals-by-team':
			return SearchInProgressFaxTotalsByTeamViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-fax-order-signature':
			return SearchInProgressFaxOrderSignatureViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-digital-totals':
			return SearchInProgressDigitalTotalsViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-digital-totals-by-physician':
			return SearchInProgressDigitalTotalsByPhysicianViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-digital-totals-by-patient':
			return SearchInProgressDigitalTotalsByPatientViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-digital-totals-by-order-type':
			return SearchInProgressDigitalTotalsByOrderTypeViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-digital-totals-by-team':
			return SearchInProgressDigitalTotalsByTeamViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-digital-order-signature':
			return SearchInProgressDigitalOrderSignatureViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-courier-totals':
			return SearchInProgressCourierTotalsViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-courier-totals-by-physician':
			return SearchInProgressCourierTotalsByPhysicianViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-courier-totals-by-patient':
			return SearchInProgressCourierTotalsByPatientViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-courier-totals-by-order-type':
			return SearchInProgressCourierTotalsByOrderTypeViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-courier-totals-by-team':
			return SearchInProgressCourierTotalsByTeamViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'in-progress-courier-order-signature':
			return SearchInProgressCourierOrderSignatureViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'oasis-export-batch':
			return SearchOasisExportBatchViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'oasis-assessment':
			return SearchOasisAssessmentViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'oasis-definitions':
			return SearchOasisDefinitionsViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'user':
			return SearchUserViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'supply':
			return SearchSupplyViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'supplier':
			return SearchSupplierViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'physician':
			return SearchPhysicianViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'physician-group':
			return SearchPhysicianGroupViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'pharmacy':
			return SearchPharmacyViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'insuranc-provider-plans':
			return SearchInsurancProviderPlansViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'insurance-provider':
			return SearchInsuranceProviderViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'icd-diagnosis':
			return SearchIcdDiagnosisViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'facility':
			return SearchFacilityViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'concept':
			return SearchConceptViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'concept-categories':
			return SearchConceptCategoriesViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'branch':
			return SearchBranchViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'legacy-wound-patient':
			return SearchLegacyWoundPatientViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'legacy-clinician':
			return SearchLegacyClinicianViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'legacy-user':
			return SearchLegacyUserViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'schedule-report-totals-discpline':
			return SearchScheduleReportTotalsDiscplineViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'schedule-report-totals-discpline-unassigned':
			return SearchScheduleReportTotalsDiscplineUnassignedViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'schedule-report-totals-patient':
			return SearchScheduleReportTotalsPatientViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'schedule-report-totals-patient-unassigned':
			return SearchScheduleReportTotalsPatientUnassignedViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'schedule-report-assigned-to':
			return SearchScheduleReportAssignedToViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'schedule-report-patient':
			return SearchScheduleReportPatientViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'schedule-report-primary-insurance':
			return SearchScheduleReportPrimaryInsuranceViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'schedule-report-admitted-episode-totals':
			return SearchScheduleReportAdmittedEpisodeTotalsViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'schedule-report-totals-assigned-to':
			return SearchScheduleReportTotalsAssignedToViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'schedule-report':
			return SearchScheduleReportViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'schedule-report-totals-team':
			return SearchScheduleReportTotalsTeamViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'schedule-report-totals-team-unassigned':
			return SearchScheduleReportTotalsTeamUnassignedViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'legacy-referral':
			return SearchLegacyReferralViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'legacy-referral-notification':
			return SearchLegacyReferralNotificationViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'legacy-chart-profiles':
			return SearchLegacyChartProfilesViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'legacy-current-patient':
			return SearchLegacyCurrentPatientViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'legacy-patients':
			return SearchLegacyPatientsViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'legacy-oasis-tracking':
			return SearchLegacyOasisTrackingViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'legacy-oasis-tracking-averages':
			return SearchLegacyOasisTrackingAveragesViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'careport-facility':
			return SearchCareportFacilityViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'careport-stays':
			return SearchCareportStaysViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'careport-visits':
			return SearchCareportVisitsViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'pending-referral':
			return SearchPendingReferralViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'patient':
			return SearchPatientViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'ntfc':
			return SearchNtfcViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'certification-period':
			return SearchCertificationPeriodViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'admission':
			return SearchAdmissionViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'hospital-event':
			return SearchHospitalEventViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'acute-visit':
			return SearchAcuteVisitViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'infection':
			return SearchInfectionViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'frequency':
			return SearchFrequencyViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'laboratory':
			return SearchLaboratoryViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'lab-definition':
			return SearchLabDefinitionViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'stored-document':
			return SearchStoredDocumentViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'patient-physician':
			return SearchPatientPhysicianViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'patient-physician-appointment':
			return SearchPatientPhysicianAppointmentViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'patient-demographics':
			return SearchPatientDemographicsViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'care-team':
			return SearchCareTeamViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'care-feed-event':
			return SearchCareFeedEventViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'concept-documentation':
			return SearchConceptDocumentationViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'intervention-definitions':
			return SearchInterventionDefinitionsViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'goal-definitions':
			return SearchGoalDefinitionsViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'notice-of-admission':
			return SearchNoticeOfAdmissionViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'patient-insurance':
			return SearchPatientInsuranceViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'face-to-face':
			return SearchFaceToFaceViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'billing-period':
			return SearchBillingPeriodViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		case 'billable-visit':
			return SearchBillableVisitViewModelProps as SearchOptionProps<SearchTypeToModel[K]>;
		default:
			throw Error('Unable to determine search type');
	}
}
